import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { GET_DATA_PROPERTY, UPDATE_DATA_PROPERTY } from "../../../../queries";

const PropertiesProfile = (props: any) => {
    // Source with all HASURA fields
    const [property, setProperty] = useState<any>(null);

    // Individual HASURA Fields
    const [selected_name, setSelected_name] = useState<any>(null);
    const [selected_shortcode, setSelected_shortcode] = useState<any>(null);
    const [selected_unit_id, setSelected_unit_id] = useState<any>(null);
    const [selected_category_id, setSelected_category_id] = useState<any>(null);
    const [selected_type_id, setSelected_type_id] = useState<any>(null);

    useEffect(() => {
        (async function fetchData() {
            await load();
        })();
    }, [props.propertyId]);

    const load = async () => {
        console.log("PropertiesProfile > props", props)
        loadSource(props.client,props.propertyId)
    }

    const loadSource = (client:any,propertyId:number) => {
        console.log(propertyId)
        var data = {
            id: propertyId
        };
        client.query({
            query: GET_DATA_PROPERTY,
            variables: data,
            fetchPolicy: "no-cache"
        }).then((result: any) => {
            console.log('GET_DATA_PROPERTY result', result);
            setProperty(result.data.syncarto_dw_property[0]);
            setSelected_name(result.data.syncarto_dw_property[0].name);
            setSelected_shortcode(result.data.syncarto_dw_property[0].shortcode);
            setSelected_unit_id(result.data.syncarto_dw_property[0].unit_id);
            setSelected_category_id(result.data.syncarto_dw_property[0].category_id);
            setSelected_type_id(result.data.syncarto_dw_property[0].type_id);
        });
    }  
    
    const handleChange_name = (e:any) => {
        setSelected_name(e.target.value);
    }     
    
    const handleChange_shortcode = (e:any) => {
        setSelected_shortcode(e.target.value);
    }      
    
    const handleChange_unit_id = (e:any) => {
        let _value:any = parseInt(e.target.value);
        if (isNaN(_value)){
            _value = null;
        }
        setSelected_unit_id(_value);
    }
          
    const handleChange_category_id = (e:any) => {
        let _value:any = parseInt(e.target.value);
        if (isNaN(_value)){
            _value = null;
        }
        setSelected_category_id(_value);
    }     
    
    const handleChange_type_id = (e:any) => {
        let _value:any = parseInt(e.target.value);
        if (isNaN(_value)){
            _value = null;
        }
        setSelected_type_id(_value);
    }   

    const updateProperty = async (e:any) => {
        props.client.mutate({
            mutation: UPDATE_DATA_PROPERTY,
            variables: {
				id: property.id,
				name: selected_name,
                shortcode: selected_shortcode,
                category_id: selected_category_id,
                unit_id: selected_unit_id,
                type_id: selected_type_id,
            },
            optimisticResponse: null,
        })
        setTimeout(() => {
            props.shouldRefreshProperties(); 
        }, 500);
    }

    if(!property) { 
        return (
            <div>loading...</div>
        );
    }

    console.log(props.formOptions)
    return (
        <>
            <h4>Update Property</h4>  
            <Form style={{ marginTop: "10px", padding:"1em" }}>
                <Form.Group as={Row} controlId="form_name">
                    <Form.Label column sm="3">
                        Name                    
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="text" onChange={handleChange_name} value={selected_name ? selected_name : ''}/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="form_shortcode">
                    <Form.Label column sm="3">
                        Shortcode
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control type="text" onChange={handleChange_shortcode} value={selected_shortcode ? selected_shortcode : ''}/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="form_category_id">
                    <Form.Label column sm="3">
                        Category
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control
                            as="select"
                            onChange={handleChange_category_id}
                            value={selected_category_id ? selected_category_id : ''}
                        >
                            {
                                props.formOptions.optionsFor_property_category.map((optionElement: any) => {
                                    return (
                                        <option key={optionElement.id} value={optionElement.id}>{optionElement.name}</option>
                                    );
                                })
                            }
                        </Form.Control>      
                    </Col>
                </Form.Group>              
                <Form.Group as={Row} controlId="form_type_id">
                    <Form.Label column sm="3">
                        Type
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control
                            as="select"
                            onChange={handleChange_type_id}
                            value={selected_type_id ? selected_type_id : ''}
                        >
                            {
                                props.formOptions.optionsFor_property_type.map((optionElement: any) => {
                                    return (
                                        <option key={optionElement.id} value={optionElement.id}>{optionElement.name}</option>
                                    );
                                })
                            }
                        </Form.Control>      
                    </Col>
                </Form.Group>              
                <Form.Group as={Row} controlId="form_unit_id">
                    <Form.Label column sm="3">
                        Unit
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control
                            as="select"
                            onChange={handleChange_unit_id}
                            value={selected_unit_id ? selected_unit_id : ''}
                        >
                            {
                                props.formOptions.optionsFor_property_unit.map((optionElement: any) => {
                                    return (
                                        <option key={optionElement.id} value={optionElement.id}>{optionElement.name} {  optionElement.abbrv ? "(" + optionElement.abbrv + ")" : ""}</option>
                                    );
                                })
                            }
                        </Form.Control>      
                    </Col>
                </Form.Group>
                <div style={{paddingTop: "7px"}}>
                    <Button variant="warning" onClick={updateProperty}>Update Property</Button>
                </div>
            </Form>
        </>
    );
}

export default PropertiesProfile;